import React from 'react';
import RepVisitsNotificationsRequestsVirtual from '../RepVisitsNotificationsRequestsVirtual';

const RepVisitsNotificationsRequests = (props) => (
  <RepVisitsNotificationsRequestsVirtual {...props} />
);

export default RepVisitsNotificationsRequests;
